<template>
    <div v-if="isInput" class="field on-focus">
        <p :class="'field-name'">{{label}}</p>
        <div v-if="value instanceof Array">
            <p v-for="(val, key) in value" :key="key">{{getValue(val)}}</p>
        </div>
        <div v-else>
            <p>{{getValue(value)}}</p>
        </div>
    </div>
    <div v-else class="field on-focus">
        <p :class="'field-name'">{{label}}</p>
        <div v-if="value instanceof Array">
            <input-field v-for="(val, index) in value" :value="val" :key="index" :type="type" :options="viewMode"
            ></input-field>
        </div>
        <div v-else>
            <input-field :value="value" :options="viewMode" :type="type"
            ></input-field>
        </div>
    </div>
</template>

<script>

    import moment from 'moment'
    import InputField from "./InputField";

    const fieldTypes = ['text', 'password', 'select', 'textarea', 'date', 'number', 'url', 'tel', 'group'];

    export default {
        name: 'field-wrapper-disabled',
        components: {
            InputField
        },
        props: {
            type: String,
            label: String,
            options: Object,
            value: undefined,
        },
        data() {
            return {

            }
        },
        computed: {
            viewMode() {
                let opt = Object.assign({}, this.options);
                opt.viewMode = true;
                return opt
            },
            isInput() {
                return fieldTypes.indexOf(this.type) !== -1
            }
        },
        methods: {
            getValue(val) {
                if(val instanceof Date) {
                    return moment(val).format('DD/MM/YYYY');
                }
                return val ? val : '-'
            },
        },
    }
</script>


<style scoped>

</style>
